module.exports = __webpack_public_path__ + "img/terrorism-1.0ffa9363.png";